import { render } from "./UploadFileForm.vue?vue&type=template&id=4c2f2436&ts=true"
import script from "./UploadFileForm.vue?vue&type=script&lang=ts"
export * from "./UploadFileForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/UploadFileForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c2f2436"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c2f2436', __exports__)) {
    api.reload('4c2f2436', __exports__)
  }
  
  module.hot.accept("./UploadFileForm.vue?vue&type=template&id=4c2f2436&ts=true", () => {
    api.rerender('4c2f2436', render)
  })

}


export default __exports__